module.exports = __webpack_public_path__ + "static/media/summits.7af019cb.svg";